module.exports = __webpack_public_path__ + "static/media/iphone_11_yellow.6c919512.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_11_yellow.png
// module id = 2074
// module chunks = 0